export const formatNumber = (value: number): string => {
  if (isNaN(value) || !isFinite(value)) {
    return '0';
  }

  return value.toLocaleString('fr-FR', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  });
};

export const formatNumberWithUnit = (value: number, unit: string): string => {
  return `${formatNumber(value)} ${unit}`;
};

export const formatImpactPerM2 = (value: number): string => {
  return formatNumberWithUnit(value, 'kg CO₂e/m²');
};

export const formatTotalImpact = (value: number): string => {
  const tons = value / 1000;
  return formatNumberWithUnit(tons, 'tons CO₂e');
};

export const formatWeight = (value: number): string => {
  return formatNumberWithUnit(value, 'kg');
};

export const formatCO2eSaved = (value: number): string => {
  return formatNumberWithUnit(value, 'kg CO₂e');
};
